import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { DeliveryAreaService } from '../../../../../delivery-area.service';
import { AccVentureDropout } from '../venture-dropouts-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialogService: DialogService, areaService: DeliveryAreaService): GridSetup<AccVentureDropout> {

	const staffPermissions = areaService.staffPermissions();

	return {
		rowName: { singular: 'Venture Dropout', plural: 'Venture Dropouts' },
		getRowKey: row => '' + row.dropoutId,
		stateKey: 'delivery-venture-dropouts-grid',
		actions: getActions(dialogService, areaService),
		buttons: [],
		columns: getColumns(util),
		downloadOptions: {
			canDownload: staffPermissions.canDownloadProgramData,
			canDownloadPersonalInfo: staffPermissions.canDownloadProgramDataWithPersonalInfo,
			fileName: `${areaService.selectedTrimesterName()}-Venture-Dropouts`
		}
	}
}
